// P0-02 scaffold screen. Shows the app is wired end to end: version from
// Vite's define, git commit from CI, and a successful /healthz round-trip
// so the owner can see the API answered.

import { useEffect, useState } from "react";

type Health = { status: string; version: string; commit: string };

const VERSION = import.meta.env.VITE_APP_VERSION ?? "0.0.1";
const COMMIT = import.meta.env.VITE_GIT_COMMIT ?? "dev";
const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:3001";

export function App() {
  const [health, setHealth] = useState<Health | "loading" | "error">("loading");

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/healthz`)
      .then((r) => (r.ok ? (r.json() as Promise<Health>) : Promise.reject(new Error(r.statusText))))
      .then((h) => {
        if (!cancelled) setHealth(h);
      })
      .catch(() => {
        if (!cancelled) setHealth("error");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main className="min-h-screen bg-white flex items-center justify-center p-8 font-sans">
      <div className="max-w-xl w-full space-y-6 text-center">
        <h1 className="text-5xl font-semibold text-[#052460]">BetterPOS</h1>
        <p className="text-slate-600">Down Range Guns & Ammo · Maple Grove, MN</p>
        <dl className="grid grid-cols-2 gap-x-4 gap-y-2 text-left bg-slate-50 rounded-lg p-6">
          <dt className="font-medium text-slate-700">Version</dt>
          <dd className="font-mono text-slate-900">v{VERSION}</dd>
          <dt className="font-medium text-slate-700">Commit</dt>
          <dd className="font-mono text-slate-900">{COMMIT}</dd>
          <dt className="font-medium text-slate-700">API</dt>
          <dd className="font-mono">
            {health === "loading" && <span className="text-slate-500">checking…</span>}
            {health === "error" && (
              <span className="text-red-600">not responding at {API_URL}</span>
            )}
            {typeof health === "object" && (
              <span className="text-green-700">
                {health.status} · v{health.version}
              </span>
            )}
          </dd>
        </dl>
        <p className="text-xs text-slate-400">P0-02 scaffold. No features yet.</p>
      </div>
    </main>
  );
}
